module.exports = __webpack_public_path__ + "img/logo.68c92bbf.svg";